module.exports = __webpack_public_path__ + "static/thumb-f69dca0f70ed09878c94bebd02300295.png";